import React, { useState, useEffect } from "react";
import styles from "../PricingFAQs/PricingFAQs.module.css";
import TitleBar2 from "../../TitleBar/TitleBar2";
const faqs = [
  {
    question: "Do I have to pay for each agent account?",
    answer:
      "Yes, we charge a fee for every agent account created, regardless of whether the agent is logged in or not. It is a long–established fact that a reader is distracted by the readable content page when looking.",
  },
  {
    question: "Can Rexpt handle multiple calls at the same time?",
    answer:
      "Yes, Rexpt can handle multiple concurrent calls without interruption, ensuring smooth communication for all users simultaneously.",
  },
  {
    question: "Is there a limit on active agents?",
    answer:
      "No, you can add as many agents as needed. Each agent has their own login and dashboard to manage calls effectively.",
  },
  {
    question: "Can I upgrade or downgrade my plan anytime?",
    answer:
      "Absolutely! You can modify your plan at any time based on your business needs, directly from your account settings.",
  },
  {
    question: "Is technical support included in all plans?",
    answer:
      "Yes, all our plans include technical support to ensure your system runs smoothly and without interruptions.",
  },
  {
    question: "Can I cancel my plan anytime?",
    answer:
      "Yes, you can cancel anytime from your account settings without additional charges or penalties.",
  },
  {
    question: "Can I customize my agents’ access?",
    answer:
      "Of course. You can set individual permissions and access levels for each agent based on your organization’s structure.",
  },
  {
    question: "Is data stored securely on your platform?",
    answer:
      "Yes, all data is encrypted and securely stored to ensure maximum privacy and protection of your company’s information.",
  },
];

const PricingFAQs = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);

  // Check screen size
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 992);
    };
    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div className={styles.containerBox}>
       <div className={styles.TitleBarDiv}>
        <TitleBar2 title="Common question & answers" subTitle="Pricing" spanText=" FAQs" />
      </div>
      <div className={styles.container}>
        <div className={styles.grid}>
          {faqs.map((faq, index) => (
            <div key={index} className={styles.card}>
              {isMobile ? (
                <>
                  <div
                    className={styles.questionBox}
                    onClick={() => toggleFAQ(index)}
                  >
                    <h3>{faq.question}</h3>
                    <span className={styles.icon}>
                      {activeIndex === index ? "−" : "+"}
                    </span>
                  </div>
                  {activeIndex === index && (
                    <p className={styles.answer}>{faq.answer}</p>
                  )}
                </>
              ) : (
                <>
                  <h3>{faq.question}</h3>
                  <p>{faq.answer}</p>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PricingFAQs;
